import React from 'react';
import { Container } from 'reactstrap';
import {
    DashboardPageHeader,
    ComingSoonCard,
    ModuleLandingGrid,
    ModuleShortcutCard,
} from '../../Components/Common/DashboardKit';

/**
 * Sales module landing page.
 *
 * UI-only refactor (Pass 1): swapped video <ComingSoon> for
 * <ComingSoonCard>; added a shortcut to Contract Review which Sales
 * users already use. Route is wrapped in <RoleProtected requireManager>
 * in allRoutes.js.
 */
const Sales = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-line-chart-line"
                        eyebrow="Revenue"
                        title="Sales"
                        subtitle="Pipeline, quotes, and revenue at a glance"
                        tone="amber"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Sales" },
                        ]}
                    />

                    <ModuleLandingGrid
                        title="Sales tools"
                        icon="ri-briefcase-line"
                        description="Existing workflows used by the sales team"
                    >
                        <ModuleShortcutCard
                            icon="ri-file-text-line"
                            label="Contract Review"
                            subtitle="Author and archive contract reviews"
                            tone="warning"
                            to="/contract-review"
                        />
                    </ModuleLandingGrid>

                    <ComingSoonCard
                        icon="ri-line-chart-line"
                        title="Sales analytics are coming soon"
                        message="Pipeline summaries, quote-to-order conversion, and revenue forecasts will land here. Use Contract Review above to manage active CRs in the meantime."
                        tone="warning"
                        features={[
                            "Pipeline by stage",
                            "Quote-to-order conversion rate",
                            "Revenue forecast vs target",
                            "Top customers and accounts",
                        ]}
                        contact="Reach out to Sales for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Sales;
